import React from 'react'
import { useNavigate } from 'react-router'
import Button from '../../../../components/Elements/Button'
const Landing: React.FC = () => {
    const navigate = useNavigate()

    const handleStart = () => {
        navigate('/auth/login')
    }
    return (
        <div className="bg-white h-[100vh] flex items-center">
            <div className="max-w-7xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                    <span className="block">Orion React boilerplate</span>
                </h2>
                <p>Showcasing Best Practices For Building React Applications</p>
                <div className="mt-8 flex justify-center">
                    <div className="inline-flex rounded-md shadow">
                        <Button onClick={handleStart}>Get started</Button>
                    </div>
                    <div className="ml-3 inline-flex">
                        <a
                            href="https://github.com/alan2207/bulletproof-react"
                            target="_blank"
                            rel="noreferrer"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
        // <>
        //     <Toast>
        //         <Toast.Header>
        //             <img
        //                 src="holder.js/20x20?text=%20"
        //                 className="rounded me-2"
        //                 alt=""
        //             />
        //             <strong className="me-auto">Bootstrap</strong>
        //             <small>11 mins ago</small>
        //         </Toast.Header>
        //         <Toast.Body>Hello, world! This is a toast message.</Toast.Body>
        //     </Toast>
        //     <input
        //         type="text"
        //         onChange={(e) => {
        //             handleSearch(e.target.value)
        //         }}
        //         placeholder="Search..."
        //     />
        //     <BootstrapTable
        //         keyField="id"
        //         data={products}
        //         columns={columns}
        //         bootstrap4={true}
        //         hover={true}
        //         search={{ onSearch: handleSearch }}
        //     />
        // </>
    )
}

export default Landing
